import axios from 'axios'

export default function ResubmitCallback(props: any) {
  const session: any = localStorage.getItem('kt-auth-react-v')?.replace(/"/g, '')
  const SISPAY_API = String(process.env.REACT_APP_SISPAY_API)
  let selectedArray: any = props.selectedArray
  let setSelectedArray: any = props.setSelectedArray
  let depositFilterBtn: any = props.depositFilterBtn

  function bulkResubmitCallback(selectedArray: any) {
    if (selectedArray.length !== 0) {
      axios
        .post(
          `${SISPAY_API}/cash/merchantcallback/manual`,
          {
            request: {
              session: session,
              depositReqs: selectedArray,
            },
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        .then(function (response) {
          if (response.data.code == '200') {
            setSelectedArray([])
            depositFilterBtn.current.click()
            alert(response.data.message)
          }
        })
        .catch(function (error) {
          alert(error)
        })
    }
  }

  return (
    <div
      className='modal fade'
      id='kt_modal_resubmit_callback'
      data-bs-backdrop='static'
      data-bs-keyboard='false'
      tabIndex={-1}
      aria-labelledby='staticBackdropLabel'
      aria-hidden='true'
    >
      <div className='modal-dialog modal-dialog-centered'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h1 className='modal-title fs-5' id='staticBackdropLabel'>
              Bulk Resubmit Callback
            </h1>
            <button
              type='button'
              className='btn-close'
              data-bs-dismiss='modal'
              aria-label='Close'
            ></button>
          </div>
          <div className='modal-body d-flex flex-wrap'>
            {selectedArray.length > 0
              ? selectedArray.map((data: any, index: number) => {
                  return (
                    <div
                      className='d-flex d-flex-column me-5 mb-5'
                      style={{
                        width: 'auto',
                      }}
                    >
                      <div
                        style={{
                          width: 'auto',
                          backgroundColor: 'grey',
                          padding: '0 10px 0 10px',
                          color: 'white',
                          textAlign: 'center',
                          borderRadius: '5px',
                        }}
                      >
                        {' '}
                        {data.id}
                      </div>
                    </div>
                  )
                })
              : 'No Deposit Record Selected'}
          </div>
          <div className='modal-footer'>
            <button type='button' className='btn btn-secondary' data-bs-dismiss='modal'>
              Close
            </button>
            {selectedArray.length > 0 && (
              <button
                type='button'
                className='btn btn-danger'
                data-bs-dismiss='modal'
                onClick={() => {
                  bulkResubmitCallback(selectedArray)
                  setSelectedArray([])
                }}
              >
                Bulk Resubmit Callback
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
